import axios from "axios";
import { isEmpty } from "lodash";
import { stringify } from "qs";
import APIResponseDto, { APIRequestDto } from "../dtos/api.dto";

const API_URL = process.env.REACT_APP_API_URL;
const API_URL_V2 = process.env.REACT_APP_API_URL_V2;
const needBasicAuth = process.env.REACT_APP_BASIC_AUTH;

/**
 * A wrapper function to decorate API call with axios
 *
 * @param path 				API url
 * @param method 			HTTP method
 * @param payload 			Payload
 * @param params 			Request params
 * @param version           API endpoint Version
 * @param token 			Bearer token
 * @param header 			HTTP header
 * @param responseType 		specific response type
 * @returns promise
 */
export const api = async (
	path: string,
	method = "GET",
	payload: any,
	params?: any,
	version?: any,
	token = "",
	header = "json",
	responseType = ""
) => {
	//check API version
	const checkVersion = (v: number) => {
		switch (v) {
			case 1:
				return API_URL;

			case 2:
				return API_URL_V2;
			default:
				return API_URL;
		}
	};

	const options: any = {
		url: checkVersion(version) + path,
		method: method.toUpperCase(),
		headers: {},
		timeout: 1000000000000000,
	};

	if (!isEmpty(params)) {
		options["url"] =
			options["url"] + stringify(params, { addQueryPrefix: true });
	}

	if (token) {
		options["headers"]["Authorization"] = "Bearer " + token;
	}

	if (!token && needBasicAuth) {
		options["auth"] = {
			username: process.env.REACT_APP_AUTH_USER_NAME,
			password: process.env.REACT_APP_AUTH_PASSWORD,
		};
	}

	//this will work with all kind of payload
	if (!isEmpty(payload) || !!payload?.entries()) {
		options["data"] = payload;
	}

	if (responseType) {
		options["responseType"] = responseType;
	}

	switch (header) {
		// if multipart ignore the option headers
		case "multipart":
			options["headers"]["Content-Type"] = "multipart/form-data";
			break;
		case "csv":
			options["headers"]["Accept"] = "application/csv";
			options["responseType"] = "blob";
			break;
		default:
			options["headers"]["Content-Type"] = "application/json";
	}
	return axios(options);
};

/**
 * check error code from api result which was resolved after the react query mutation
 * if error code is not zero, throw with error message from api
 *
 * @param response
 * @param cb
 */
export function apiResolver(response: any, cb = (response: any) => null) {
	if (response.status !== 200) {
		// TODO: show only something went wrong exception if the environment is for the production;
		return Promise.reject({ ...response });
	} else {
		return cb(response);
	}
}

/**
 * Extract actual data from the api
 * @param data
 */
export const apiSelector = (data: any) =>
	apiResolver(data, (response: any) => response);
